import { Helmet } from '@act/react-helmet-async'
import { NavLink, Outlet, useNavigate } from 'react-router-dom'
import Box from '@mui/material/Box'
import Drawer from '@mui/material/Drawer'
import List from '@mui/material/List'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import Divider from '@mui/material/Divider'
import Toolbar from '@mui/material/Toolbar'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import { logout } from '../../api/auth'

const DRAWER_WIDTH = 220

const links = [
  { label: 'Races', to: '/admin/dashboard/races' },
  { label: 'Events', to: '/admin/dashboard/events' }
]

export default function AdminLayout () {
  const navigate = useNavigate()

  const handleLogout = async () => {
    await logout()
    navigate('/admin/login', { replace: true })
  }

  return (
    <>
      <Helmet>
        <meta name='robots' content='noindex' />
        <title>Admin — Peaks Sports</title>
      </Helmet>
      <Box sx={{ display: 'flex', minHeight: '70vh' }}>
        <Drawer
          variant='permanent'
          sx={{
            width: DRAWER_WIDTH,
            flexShrink: 0,
            '& .MuiDrawer-paper': { width: DRAWER_WIDTH, boxSizing: 'border-box' }
          }}
        >
          <Toolbar />
          <Box sx={{ px: 2, pb: 1 }}>
            <Typography variant='subtitle1' sx={{ fontWeight: 700 }}>Admin Dashboard</Typography>
          </Box>
          <Divider />
          <List>
            {links.map(link => (
              <ListItemButton
                key={link.to}
                component={NavLink}
                to={link.to}
                sx={{
                  '&.active': { bgcolor: 'action.selected', fontWeight: 600 }
                }}
              >
                <ListItemText primary={link.label} />
              </ListItemButton>
            ))}
          </List>
          <Divider />
          <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Button size='small' variant='outlined' component='a' href='/' target='_blank' rel='noopener noreferrer'>
              View site
            </Button>
            <Button size='small' color='error' variant='text' onClick={handleLogout}>
              Logout
            </Button>
          </Box>
        </Drawer>
        <Box
          component='main'
          sx={{
            flexGrow: 1,
            p: 3,
            ml: `${DRAWER_WIDTH}px`,
            '& .MuiOutlinedInput-root': { backgroundColor: 'background.paper' },
            '& .MuiOutlinedInput-notchedOutline': {
              border: '1px solid',
              borderColor: 'divider'
            },
            '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: 'primary.main',
              borderWidth: '2px'
            }
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </>
  )
}
